import React, { Component } from "react";
import { 
    Button,
    Icon,
    FormGroup,
    InputGroup,
    Menu,
    MenuItem,
    Classes,
    Dialog,
    Callout } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import { Trans } from "react-i18next";

import { TimePicker } from "@blueprintjs/datetime";

import i18next from 'i18next';


export const DayOfWeek = {
    Monday: {label:"monday", id:0},
    Tuesday: {label:"tuesday", id:1},
    Wednesday: {label:"wednesday", id:2},
    Thursday: {label:"thursday", id:3},
    Friday: {label:"friday", id:4},
    Saturday: {label:"saturday", id:5},
    Synday: {label:"sunday", id:6}
}


export function getDayOfWeekLabel(id){
    let resultId = undefined;
    const list = Object.values(DayOfWeek);
    list.forEach(val =>{
        if(id === val.id){
            resultId = i18next.t(val.label)
        }
    });
    return resultId;
}
//Type definition
// const TimePeriodData = {
//     label: '',
//     date:[
//         {
//         startDay: 0,
//         startHour: 0,
//         startMinutes: 0,
//         endDay: 0,
//         endHour: 0,
//         endMinutes: 0,
//         }
//     ]
// }

export default class TimePeriode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addPeriode: false,
            new_label: '',
            new_startday: undefined,
            new_starthour: 0,
            new_startminute: 0,
            new_endday: undefined,
            new_endhour: 0,
            new_endminute: 0,
            new_dateperiode: [],
        };        
    }

    componentDidMount() {
              
    }
    getDayOfWeek(){
        const list = Object.values(DayOfWeek);
        return list.map(val =>{
            return {label:i18next.t(val.label), id:val.id};
        });
    }
    isValidPeriodeDisabled(){
        let ret = true;
        if (this.state.new_startday !== undefined && this.state.new_endday !== undefined
        && (this.state.new_starthour + this.state.new_startminute) !== (this.state.new_endhour + this.state.new_endminute)){
            ret = false;
        }        
        return ret;
    }
    isValidConfigDisabled(){
        let ret = true;
        if (this.state.new_label && this.state.new_label.length > 0
        && this.state.new_dateperiode.length > 0 && this.props.updateTimePeriodCB){
            ret = false;
        }        
        return ret;
    }
    render() {
        return (
          <div>
            <Callout title={<Trans>Select pricing periods</Trans>}>
                <Callout  >                    
                    {this.props.data.map((val, index) =>{
                        return (
                            <>
                                <span>
                                    <Icon icon="tag" /> <Trans>label</Trans>: {val.label}
                                    <Button
                                        text={<Trans>delete</Trans>}
                                        intent="danger"
                                        icon="cross"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if(this.props.deleteItemCB){
                                                this.props.deleteItemCB(index);
                                            }
                                        }}/>
                                        
                                </span>
                                <ul>
                                {val.date.map((d)=>{
                                    return (
                                        <li>
                                            <Trans>from</Trans>: {getDayOfWeekLabel(d.startDay)} <Trans>at</Trans>  {('0' + d.startHour).slice(-2)}:{('0' + d.startMinutes).slice(-2)} {" "}
                                            <Trans>to</Trans>: {getDayOfWeekLabel(d.endDay)} <Trans>at</Trans>  {('0' + d.endHour).slice(-2)}:{('0' + d.endMinutes).slice(-2)}
                                        </li>)
                                })}
                                </ul>
                            </>
                        )
                    })}
                </Callout>

                <Button icon="add" text={i18next.t("add")} onClick={() => this.setState({ addPeriode: true, input_parks: [] })} />
                    <Dialog
                        style={{ transition: 'none' }}
                        isOpen={this.state.addPeriode}
                        canEscapeKeyClose={true}
                        canOutsideClickClose={true}
                        onClose={() => this.setState({ addPeriode: false })}
                        title={<Trans>add time periode</Trans>}
                    >
                        <div className={Classes.DIALOG_BODY}>
                        <FormGroup label={<Trans>label</Trans>} labelFor="input_name">
                            <InputGroup
                            id="input_name"
                            onChange={(ti) => this.setState({ new_label: ti.target.value })}
                            leftIcon="label"
                            large={true}
                            placeholder={i18next.t('period name')}
                            />
                        </FormGroup>

                        <Callout title={<Trans>Resume</Trans>} intent="normal" >
                            <ul>
                                {this.state.new_dateperiode.map(val =>{
                                    return (<li>
                                    <Trans>from</Trans>: {getDayOfWeekLabel(val.startDay)} <Trans>at</Trans>  {('0' + val.startHour).slice(-2)}:{('0' + val.startMinutes).slice(-2)} {" "}
                                    <Trans>to</Trans>: {getDayOfWeekLabel(val.endDay)} <Trans>at</Trans>  {('0' + val.endHour).slice(-2)}:{('0' + val.endMinutes).slice(-2)}
                                    </li>)
                                })}
                            </ul>
                        </Callout>

                        <div  className="flexbox-left">
                        <Callout title={<Trans>beginning of period</Trans>} intent="success" icon="tag">
                            <FormGroup label={<Trans>day of week</Trans>} labelFor='input_description'>
                                <Select
                                    items={this.getDayOfWeek()}
                                    itemRenderer={(item, { selecttt, modifiers }) => {
                                    return <MenuItem
                                        label={item.label}
                                        text={item.label}
                                        onClick={() => {
                                        this.setState({ new_startday: item.id});
                                        }}
                                        itemListRenderer={({ items, itemsParentRef, query, renderItem }) => {
                                        const renderedItems = items.map(renderItem).filter(item => (item != null && item.id === this.state.new_startday));
                                        return (
                                            <Menu ulRef={itemsParentRef}>
                                            <MenuItem
                                                disabled={true}
                                            />
                                            {renderedItems.label}
                                            </Menu>
                                        );
                                        }}
                                    />
                                    }}
                                >
                                <Button text={this.state.new_startday === undefined ? i18next.t("select a day"): getDayOfWeekLabel(this.state.new_startday)} rightIcon="double-caret-vertical" />
                            </Select>
                            </FormGroup>


                            <FormGroup label={<Trans>start time</Trans>} labelFor="input_applicable">
                                <TimePicker
                                    showArrowButtons={true}
                                    value={
                                    new Date(
                                        new Date().setHours(
                                        parseInt(this.state.new_starthour, 10),
                                        parseInt(this.state.new_startminute, 10)
                                        )
                                    )
                                    }
                                    onChange={(time) => {
                                        this.setState({new_starthour: time.getHours().toString(10), new_startminute: time.getMinutes().toString(10)});
                                    }}
                                />
                            </FormGroup>
                        </Callout>
                        </div>
                        <div  className="flexbox-left">
                        <Callout title={<Trans>end of period</Trans>} intent="success" icon="tag">
                            <FormGroup label={<Trans>day of week</Trans>} labelFor='input_description'>
                                <Select
                                    items={this.getDayOfWeek()}
                                    itemRenderer={(item, { selecttt, modifiers }) => {
                                    return <MenuItem
                                        label={item.label}
                                        text={item.label}
                                        onClick={() => {
                                        this.setState({ new_endday: item.id});
                                        }}
                                        itemListRenderer={({ items, itemsParentRef, query, renderItem }) => {
                                        const renderedItems = items.map(renderItem).filter(item => (item != null && item.id === this.state.new_endday));
                                        return (
                                            <Menu ulRef={itemsParentRef}>
                                            <MenuItem
                                                disabled={true}
                                            />
                                            {renderedItems}
                                            </Menu>
                                        );
                                        }}
                                    />
                                    }}
                                >
                                <Button text={this.state.new_endday === undefined ? i18next.t("select a day"): getDayOfWeekLabel(this.state.new_endday)} rightIcon="double-caret-vertical" />
                            </Select>
                            </FormGroup>


                            <FormGroup label={<Trans>end time</Trans>} labelFor="input_applicable">
                            <TimePicker
                                showArrowButtons={true}
                                value={
                                new Date(
                                    new Date().setHours(
                                    parseInt(this.state.new_endhour, 10),
                                    parseInt(this.state.new_endminute, 10)
                                    )
                                )
                                }
                                onChange={(time) => {
                                    this.setState({new_endhour: time.getHours().toString(10), new_endminute: time.getMinutes().toString(10)});
                                }}
                            />
                            </FormGroup>
                        </Callout>
                        </div>
                        <div className="flexbox-center">
                            <FormGroup>
                                <Button
                                    text={<Trans>valid</Trans>}
                                    intent="primary"
                                    icon="add"
                                    disabled={this.isValidPeriodeDisabled()}
                                    onClick={() => {
                                        const periodList = [...this.state.new_dateperiode];
                                        periodList.push({
                                            startDay: this.state.new_startday,
                                            startHour: this.state.new_starthour,
                                            startMinutes: this.state.new_startminute,
                                            endDay: this.state.new_endday,
                                            endHour: this.state.new_endhour,
                                            endMinutes: this.state.new_endminute
                                        });
                                        this.setState({
                                            new_dateperiode: periodList, 
                                            new_startday: undefined,
                                            new_starthour: 0,
                                            new_startminute: 0,
                                            new_endday: undefined,
                                            new_endhour: 0,
                                            new_endminute: 0
                                        });
                                    }}
                                />
                                {" "}
                                <Button
                                    text={<Trans>clear</Trans>}
                                    intent="warning"
                                    icon="clean"
                                    disabled={false}
                                    onClick={() => {
                                        this.setState({
                                            new_dateperiode: [],
                                            new_label: '',
                                            new_startday: undefined,
                                            new_starthour: 0,
                                            new_startminute: 0,
                                            new_endday: undefined,
                                            new_endhour: 0,
                                            new_endminute: 0
                                        })
                                    }}
                                />
                            </FormGroup>
                        </div>
                        <div className="flexbox-center">
                            <FormGroup>
                            <Button
                                text={<Trans>add</Trans>}
                                intent="primary"
                                icon="add"
                                disabled={this.isValidConfigDisabled()}
                                onClick={() => {
                                    if(this.props.updateTimePeriodCB){
                                        const conf = {
                                            label: this.state.new_label,
                                            date: this.state.new_dateperiode
                                        }
                                        const final = [...this.props.data, conf];
                                        this.props.updateTimePeriodCB(final);
                                        this.setState({
                                            new_dateperiode: [],
                                            new_label: '', 
                                            new_startday: undefined,
                                            new_starthour: 0,
                                            new_startminute: 0,
                                            new_endday: undefined,
                                            new_endhour: 0,
                                            new_endminute: 0,
                                            addPeriode: false})
                                    }
                                }}
                            />
                            <Button
                                text={<Trans>cancel</Trans>}
                                intent="warning"
                                icon="undo"
                                style={{ marginLeft: '1em' }}
                                onClick={() => this.setState({
                                    new_dateperiode: [],
                                    new_label: '', 
                                    new_startday: undefined,
                                    new_starthour: 0,
                                    new_startminute: 0,
                                    new_endday: undefined,
                                    new_endhour: 0,
                                    new_endminute: 0,
                                    addPeriode: false })}
                            />
                            </FormGroup>
                        </div>
                        </div>
                    </Dialog>

            </Callout>
          </div>
        );
    }
}
